import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var Point = /*#__PURE__*/_createClass(function Point(position, particle) {
  _classCallCheck(this, Point);
  this.position = position;
  this.particle = particle;
});